export enum WebNotificationPurpose {
	Gabby = 'gabby',
	WonderSchedule = 'wonder-schedule',
}
